module.exports = __webpack_public_path__ + "img/close-blue-16dp.f93c9439.svg";